import { createSlice, PayloadAction } from '@reduxjs/toolkit';
// Import Types
import type { DropdownOption, WhatsappTemplateApiResponse } from 'types';

export interface WhatsAppTemplateState {
    whatsAppTemplateList: Nullable<DropdownOption<string>[]>;
    templatesByLanguage: Nullable<WhatsappTemplateApiResponse[]>;
    isLoadingTemplatesByLanguage: boolean;
}

export const initialState: WhatsAppTemplateState = {
    whatsAppTemplateList: null,
    templatesByLanguage: null,
    isLoadingTemplatesByLanguage: false,
};

export const whatsAppTemplateSlice = createSlice({
    name: 'whatsAppTemplate',
    initialState,
    reducers: (create) => ({
        setWhatsAppTemplateList: create.reducer((state, { payload }: PayloadAction<DropdownOption<string>[]>) => {
            state.whatsAppTemplateList = payload;
        }),
        setWhatsAppTemplateByLanguage: create.reducer(
            (state, { payload }: PayloadAction<Nullable<WhatsappTemplateApiResponse[]>>) => {
                state.templatesByLanguage = payload;
            },
        ),
        setWhatsAppTemplateByLanguageLoading: create.reducer((state, { payload }: PayloadAction<boolean>) => {
            state.isLoadingTemplatesByLanguage = payload;
        }),
        clearWhatsAppTemplateByLanguage: create.reducer((state) => {
            state.templatesByLanguage = null;
            state.isLoadingTemplatesByLanguage = false;
        }),
        clearWhatsAppTemplateState: create.reducer((state) => {
            state.whatsAppTemplateList = null;
            state.templatesByLanguage = null;
            state.isLoadingTemplatesByLanguage = false;
        }),
    }),
    selectors: {
        selectWhatsAppTemplateState: (whatsAppTemplate) => whatsAppTemplate,
        selectWhatsAppTemplateList: (whatsAppTemplate) => whatsAppTemplate.whatsAppTemplateList,
        selectWhatsAppTemplatesByLanguage: (whatsAppTemplate) => whatsAppTemplate.templatesByLanguage,
        selectIsWhatsAppTemplatesByLanguageLoading: (whatsAppTemplate) => whatsAppTemplate.isLoadingTemplatesByLanguage,
    },
});

export const {
    setWhatsAppTemplateList,
    setWhatsAppTemplateByLanguage,
    setWhatsAppTemplateByLanguageLoading,
    clearWhatsAppTemplateByLanguage,
    clearWhatsAppTemplateState,
} = whatsAppTemplateSlice.actions;
export const {
    selectWhatsAppTemplateState,
    selectWhatsAppTemplateList,
    selectWhatsAppTemplatesByLanguage,
    selectIsWhatsAppTemplatesByLanguageLoading,
} = whatsAppTemplateSlice.selectors;
